import React from 'react';
import Button from 'components/Button';
import { convertFromUtcToTimezone } from 'lib/helpers-time';
import TimesheetStatusPill from './TimesheetStatusPill';
import { formatHourlyRate } from '../Jobs/helpers';
import './style.scss';

export const TimesheetDetailsHeader = ({ shift, booking, ratingsFeatureIsOn, servicesFeatureFlag, onArchive, onUnarchive }) => {
  const rows = [
    ['Shift Ref', shift.shiftNumber],
    ['Candidate', booking.candidateName],
    ['Site', shift.siteName],
    ...(shift.areaName ? [['Area', shift.areaName]] : []),
    ['Date', convertFromUtcToTimezone(shift.startTime, shift.timezone).format('DD MMMM YYYY')],
    ['Scheduled time', `${convertFromUtcToTimezone(shift.startTime, shift.timezone).format('HH:mm')} – ${convertFromUtcToTimezone(shift.endTime, shift.timezone).format('HH:mm')}`],
    ['Role', booking.roleName],
    ['Grade', booking.gradeName],
    ['Speciality', shift.specialityName || 'Any'],
    ...(servicesFeatureFlag ? [['Service', shift.serviceName]] : []),
    ...(shift.customHourlyRate ? [['Hourly Rate', `£${formatHourlyRate(shift.customHourlyRate)}`]] : []),
  ];

  return (
    <div className="timesheet-header">
      <div className="timesheet-header__bar">
        <h3 className="timesheet-header__title">{`Timesheet${ratingsFeatureIsOn ? ' & Rating' : ''}`}</h3>
        <TimesheetStatusPill timesheet={{ ...booking, status: booking.timesheetStatus }} />
        {onArchive && <Button white shadow={false} className="timesheet-header__archive" onClick={onArchive}>Archive Timesheet</Button>}
        {onUnarchive && <Button white shadow={false} className="timesheet-header__unarchive" onClick={onUnarchive}>Unarchive Timesheet</Button>}
      </div>
      <div className="timesheet-header__details">
        <table className="timesheet-header__table" aria-label="Timesheet details">
          <tbody>
            {rows.map(([label, value]) => (
              <tr key={label}>
                <th scope="row">{label}</th>
                <td>{value || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
